import { SubdistrictDetailPage } from "@/features/geolocation/page/SubdistrictDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/geolocation/subdistrict/$id/detail"
)({
  component: SubdistrictDetailPage,
});
